const videojs = require('../node_modules/video.js/dist/video.es.js');
window.videojs = videojs;
require('../node_modules/videojs-contrib-ads/dist/videojs-contrib-ads.es.js');
require('../node_modules/videojs-ima/dist/videojs.ima.es.js');
require('../node_modules/can-autoplay/build/can-autoplay.es.js');
require('./applixir.iframe.js');